import { useEventDispatcher } from "@otto-ec/otto-components-utils/use/event-dispatcher";
import { untrack } from "svelte";
import { events, sheet } from "../index.js";
import type { Events, Props } from "../SheetV1.types.js";
import type { NexusEvents } from "./event.nexus.js";
import type { DetailBase, BeforeOpen } from "./event.detail.js";
import type { EventAnyDefintion, GetEventPayload } from "./event.utils.js";
import { stack } from "../stack/stack.global.svelte.js";
import {
  CONTENT_FETCH,
  CONTENT_PARSE,
  CONTENT_ERROR,
  CONTENT_APPLY,
  CONTENT_DISCARD,
} from "./event.name.defs.js";
import type { ExternalContentEvents } from "../../../../common/externalContent/events.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const dispatchSheetEvent = <E extends EventAnyDefintion>(
  event: E,
  instance: NoInfer<GetEventPayload<E>["instance"]>,
  payload: Omit<GetEventPayload<E>, "instance" | "extraData" | "id" | "cancel"> & { id?: string },
): boolean => {
  /*                                                           */
  const dispatchDom = instance ? useEventDispatcher<Events>(instance) : null;
  /*                                                              */
  const results = [] as (boolean | undefined)[];

  /*                                                              */
  const detail: DetailBase & BeforeOpen = payload as never;
  const instanceOrNull = instance as HTMLOcSheetV1Element | null;

  /*                                                */
  detail.instance = instance;
  /*                                                          */
  detail.extraData = instanceOrNull?.extraData ?? null;

  /*                                          */
  /*                                           */
  Object.defineProperty(detail, "cancel", {
    value: () => void results.push(false),
    writable: false,
    enumerable: true,
    configurable: false,
  });

  /*                                                                          */
  if (instanceOrNull?.id) detail.id = instanceOrNull?.id;

  /*                                 */
  const [apiEvent, domEvent] = event;

  /*                                   */
  events[apiEvent].dispatch(detail as never);
  results.push(dispatchDom?.(domEvent, detail as never));

  /*                                                           */
  /*                                                                                                   */
  /*                                                                               */
  const legacy = untrack(() => stack.contentChange) ? event[3] : event[2];

  /*                                     */
  legacy.forEach(([apiAlias, domAlias]) => {
    if (domAlias) results.push(dispatchDom?.(domAlias as never, detail as never));
    if (apiAlias) {
      /*          */
      events[apiAlias as keyof NexusEvents].dispatch(detail as never);
      /*               */
      (sheet[`${apiAlias}Event` as never] as NexusEvents[keyof NexusEvents]).dispatch(
        detail as never,
      );
    }
  });

  /*                                                           */
  return results.filter((r) => typeof r === "boolean").every((result) => result);
};

export const externalContentEvents: (host: HTMLOcSheetV1Element) => ExternalContentEvents<Props> = (
  Host,
) => ({
  fetch: (p) => dispatchSheetEvent(CONTENT_FETCH, Host, { ...p, info: stack.info }),
  parse: (p) => dispatchSheetEvent(CONTENT_PARSE, Host, { ...p, info: stack.info }),
  error: (p) => dispatchSheetEvent(CONTENT_ERROR, Host, { ...p, info: stack.info }),
  apply: (p) => dispatchSheetEvent(CONTENT_APPLY, Host, { ...p, info: stack.info }),
  discard: (p) => dispatchSheetEvent(CONTENT_DISCARD, Host, { ...p, info: stack.info }),
});
